<template>
  <!-- 휴대폰 확인 창 — qr2-web 성인인증과 같은 창을 같은 화면 안에 띄운다. 끝나면 같은 출처의 돌아올 자리로 와서 이 칸이 그 주소를 읽는다 -->
  <el-dialog
    :visible="visible"
    :title="title"
    :fullscreen="$device.mobile"
    width="480px"
    append-to-body
    destroy-on-close
    @update:visible="$emit('update:visible', $event)">
    <iframe v-if="visible" :src="verifyUrl" class="verify-frame" @load="onFrameLoad"></iframe>
  </el-dialog>
</template>

<script>
import { ID_VERIFICATION_URL } from '@/utils/constants'
import { phoneVerifyOutcome, phoneVerifyUrl } from '@/utils/phoneVerify'

/**
 * **휴대폰 본인확인 창 한 곳** — 처음 받은 비밀번호 재설정(`PasswordResetPanel`)과 사장님 계정 비밀번호 찾기(`OwnerPasswordReset`)가 같이 쓴다.
 * 주소·결과 판정은 `utils/phoneVerify` 한 곳이고, 여기는 창을 띄우고 그 주소를 읽는 효과만 한다.
 *
 * 끝은 하나다: 돌아올 자리에 오면 창을 닫고(`update:visible` false) `outcome` 에 `{verification}`(열쇠) 또는 `{failed: true}` 를 싣는다.
 * 그 열쇠로 무엇을 부를지는 부른 화면이 정한다.
 */
export default {
  name: 'PhoneVerifyDialog',
  props: {
    /** 창을 보이는가 — `.sync` 로 받는다 */
    visible: { type: Boolean, default: false },
    /** 창 머리 — 부른 화면의 말(번역된 것) */
    title: { type: String, default: '' },
  },
  computed: {
    verifyUrl() {
      return phoneVerifyUrl(ID_VERIFICATION_URL, window.location.origin)
    },
  },
  methods: {
    /**
     * 창이 새 문서를 열 때마다 — 남의 출처(integration-server·NICE)면 주소를 못 읽으므로 아직 창 안이다. 같은 출처의 돌아올 자리에 오면
     * 창을 닫고 결과를 알린다.
     */
    onFrameLoad(event) {
      let frameLocation = null
      try {
        const { origin, pathname, search } = event.target.contentWindow.location
        frameLocation = { origin, pathname, search }
      } catch (error) {
        return
      }

      const outcome = phoneVerifyOutcome(frameLocation, window.location.origin)
      if (!outcome) return

      this.$emit('update:visible', false)
      this.$emit('outcome', outcome)
    },
  },
}
</script>

<style scoped>
.verify-frame {
  width: 100%;
  height: 640px;
  border: none;
}
</style>
